import { appUrl } from 'utils/wrappers';
import Base from 'app/models/base';

export default Base.extend({
  urlRoot: appUrl('carrier_accounts'),
  rootKey: 'carrier_account',
});



// WEBPACK FOOTER //
// ./app/models/carrier_account.js